module.exports = __webpack_public_path__ + "img/check_icon.ccb67dad.png";